
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {IBreadcrumb} from "@/entity/common/breadcrumb.types";
import {RouterNameEnum} from '@/router/router.types';
import StudioSelect from "@/UI/components/Store/StudioSelect.vue";
import { checkUserRole } from '@/router/Lib/helper';

@Component({
  components: {StudioSelect},
  methods: {
      checkUserRole
  }
})
export default class FinanceBreadcrumbLine extends Vue {
  list: IBreadcrumb[] = [];

  @Watch('$route', {immediate: true})
  onRouteChange(): void {
    if (this.$route!.meta!.breadcrumb! === undefined) {
        this.list = this.$route.matched[this.$route.matched.length - 2].meta!.breadcrumb!;
    }else {
      this.list = this.$route!.meta!.breadcrumb!;
    }

  }
  proceed(index: number): void {
    const item = this.list[index];
    if (item.link !== undefined) {
      this.$router.push({name: item.link});
    }
  }

  addCashbox(): void {
    this.$emit('showAddCashbox', true);
  }

}
